var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonMonitoring = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M8.029 19.952H9.95a4.029 4.029 0 014.029 4.03v15.99A4.029 4.029 0 019.95 44H8.03A4.029 4.029 0 014 39.971v-15.99a4.029 4.029 0 014.029-4.029z", fill: fills.dark }),
        React.createElement("path", { d: "M38.05 11.925h1.921A4.029 4.029 0 0144 15.954v24.017A4.029 4.029 0 0139.971 44H38.05a4.029 4.029 0 01-4.029-4.029V15.954a4.029 4.029 0 014.03-4.029z", fill: fills.light }),
        React.createElement("path", { d: "M22 4h4c2.21 0 4 1.797 4 4.015v31.97A4.007 4.007 0 0126 44h-4c-2.21 0-4-1.797-4-4.015V8.015A4.007 4.007 0 0122 4z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
